import React, { useReducer } from 'react';
import axios from 'axios';
//import uuid from 'uuid';
import SubscriptionsContext from './subscriptionsContext';
import subscriptionsReducer from './subscriptionsReducer';
import {
  GET_SUBSCRIPTIONS,
  CLEAR_SUBSCRIPTIONS,
  ADD_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
  SET_CURRENT,
  CLEAR_CURRENT,
  UPDATE_SUBSCRIPTION,
  FILTER_SUBSCRIPTIONS,
  CLEAR_FILTER,
  SUBSCRIPTION_ERROR,
  GET_DROPDOWNS
} from '../types';

const SubscriptionsState = props => {
  const initialState = {
    subscriptions: null,
    dropdowns: null,
    current: null,
    filtered: null,
    error: null
  };

  const [state, dispatch] = useReducer(subscriptionsReducer, initialState);

  // Get Subscriptions
  const getSubscriptions = async id => {
    try {
      const res = await axios.get(`/api/v1/subscriptions/client/${id}`);
      dispatch({
        type: GET_SUBSCRIPTIONS,
        payload: res.data
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: SUBSCRIPTION_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Add Subscription
  const addSubscription = async subscription => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    try {
      const res = await axios.post(
        '/api/v1/subscriptions',
        subscription,
        config
      );
      dispatch({
        type: ADD_SUBSCRIPTION,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: SUBSCRIPTION_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Delete Subscription
  const deleteSubscription = async id => {
    try {
      await axios.delete(`/api/v1/subscriptions/${id}`);
      dispatch({
        type: DELETE_SUBSCRIPTION,
        payload: id
      });
    } catch (err) {
      dispatch({
        type: SUBSCRIPTION_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Update Subscription
  const updateSubscription = async subscription => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    //console.log('useStateUpdateSubscription', subscription);
    try {
      const res = await axios.put(
        `/api/v1/subscriptions/${subscription.id}`,
        subscription,
        config
      );

      dispatch({
        type: UPDATE_SUBSCRIPTION,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: SUBSCRIPTION_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Clear Subscriptions
  const clearSubscriptions = () => {
    dispatch({ type: CLEAR_SUBSCRIPTIONS });
  };

  //Set Current Client
  const setCurrent = subscription => {
    dispatch({ type: SET_CURRENT, payload: subscription });
  };

  //Clear Current Subscription

  const clearCurrent = () => {
    dispatch({ type: CLEAR_CURRENT });
  };

  //Filter Subscriptions
  const filterSubscriptions = text => {
    dispatch({ type: FILTER_SUBSCRIPTIONS, payload: text });
  };

  //Clear Filter
  const clearFilter = () => {
    dispatch({ type: CLEAR_FILTER });
  };

  //Get Dropdowns Values for Subscription Componet
  const getDropdowns = async () => {
    try {
      const res = await axios.get(
        '/api/v1/dropdowns/dropdown?component=subscriptions'
      );
      dispatch({
        type: GET_DROPDOWNS,
        payload: res.data.data
      });
    } catch (err) {
      //console.log(err);
      dispatch({
        type: SUBSCRIPTION_ERROR,
        payload: err.response.msg
      });
    }
  };

  return (
    <SubscriptionsContext.Provider
      value={{
        subscriptions: state.subscriptions,
        current: state.current,
        filtered: state.filtered,
        dropdowns: state.dropdowns,
        error: state.error,
        getSubscriptions,
        addSubscription,
        deleteSubscription,
        setCurrent,
        clearCurrent,
        updateSubscription,
        filterSubscriptions,
        clearFilter,
        clearSubscriptions,
        getDropdowns
      }}
    >
      {props.children}
    </SubscriptionsContext.Provider>
  );
};

export default SubscriptionsState;
